
// PostListSearch.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const PostListSearch = ({ searchQuery }) => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    // Fetch posts from WordPress REST API
    const apiUrl = searchQuery
      ? `https://notesbynani.com/wp-json/wp/v2/posts?search=${searchQuery}`
      : 'https://notesbynani.com/wp-json/wp/v2/posts';

    axios.get(apiUrl)
      .then(response => {
        setPosts(response.data);
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
      });
  }, [searchQuery]);

  return (
    <div>
      <h1>WordPress Posts</h1>
      {/* <ul>
        {posts.map(post => (
          <li key={post.id}>{post.title.rendered}</li>
        ))}
      </ul> */}
      <ul className='postlist'>
        {posts.map(post => (
          <li key={post.id}>
          {/* <a href={post.link} target='_blank'> */}
          <Link to={`/posts/${post.id}`}>
          <img src={post.jetpack_featured_media_url} alt="" />
          {post.title.rendered}
          {/* </a> */}
          </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PostListSearch;
